module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-header"
  }, [_c('a', {
    staticClass: "catalog-btn",
    on: {
      "click": _vm.toggleCatalog
    }
  }), _c('a', {
    staticClass: "made-by",
    attrs: {
      "href": "https://lfyfly.github.io/fly-markdown/",
      "target": "_blank",
      "title": "制作软件地址"
    }
  }, [_vm._v("made by flyMarkdown")]), _c('div', {
    staticClass: "document-header",
    class: {
      noFileInfo: _vm.IsNoFileInfo
    }
  }, [_c('h1', {
    staticClass: "document-title"
  }, [_vm._v(_vm._s(_vm.editingFile ? _vm.editingFile.fileName : 'fly-markdown'))]), (!_vm.editingFile) ? _c('a', {
    staticClass: "title-icon iconfont icon-github",
    attrs: {
      "href": "https://github.com/lfyfly/fly-markdown",
      "title": "github",
      "target": "_blank"
    }
  }) : _vm._e()]), (_vm.editingFile === null || (_vm.editingFile !== null && _vm.editingFile.info.length != 0)) ? _c('div', {
    staticClass: "document-info"
  }, _vm._l((_vm.fileInfo), function(v) {
    return _c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "info-key"
    }, [_vm._v(_vm._s(v.key + ': '))]), _c('span', {
      staticClass: "info-value"
    }, [_c('a', {
      attrs: {
        "href": _vm._f("addHttp")(v),
        "title": _vm._f("addHttp")(v),
        "target": v.link ? '_blank' : false
      }
    }, [_vm._v(_vm._s(v.value))])])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0b375081"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markdown-header/markdown-header.vue
// module id = 277
// module chunks = 1